import * as React from 'react';
import { bool, number, string, oneOfType } from 'prop-types';
import styled from 'styled-components';
import media from './fpp_media_queries';
import TextComponent from './text_component';

const ImageContainer = styled.figure({
   textAlign: 'center',
   margin: '0 10px',
});

const Image = styled.img(props => ({
   width: props.width,
   height: props.height,
   maxWidth: '100%',
   margin: 'auto',
}));

const HeadingContainer = styled.div({
   paddingBottom: 40,
   [media.mobileLandscapeAll]: {
      paddingBottom: 20,
   },
});

const ImageHeading = ({ heading }) => (
   <HeadingContainer>
      <TextComponent subheading={heading} />
   </HeadingContainer>
);

const ImageComponent = ({
   heading,
   width,
   height,
   alt,
   src,
   srcSet,
   lazyLoaded,
   className,
   imageContainer,
}) => {
   const ImageWrapper = imageContainer ? imageContainer : ImageContainer;
   return (
      <div width={width} height={height}>
         {heading && <ImageHeading heading={heading} />}
         <ImageWrapper>
            {lazyLoaded ? (
               <Image
                  className="lazyload"
                  alt={alt}
                  width={width}
                  height={height}
                  data-src={src}
                  data-srcset={srcSet}
               />
            ) : (
               <Image
                  className={className}
                  alt={alt}
                  width={width}
                  height={height}
                  src={src}
                  srcSet={srcSet}
               />
            )}
         </ImageWrapper>
      </div>
   );
};

ImageComponent.propTypes = {
   heading: string,
   width: oneOfType([string, number]),
   height: oneOfType([string, number]),
   alt: string.isRequired,
   src: string.isRequired,
   srcSet: string,
   lazyLoaded: bool,
};

ImageComponent.defaultProps = {
   heading: null,
   width: null,
   height: null,
   srcSet: null,
   alt: null,
   lazyLoaded: false,
};

export default ImageComponent;
export { ImageContainer };
